import React from 'react';
import {
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  IconButton,
} from '@mui/material';
import { ReactComponent as MoreAISvg } from '../../assets/SVG/moreAI.svg';
import { ReactComponent as DeleteIcon } from '../../assets/SVG/trash.svg';
import { ReactComponent as EditIcon } from '../../assets/SVG/Edit.svg';
import { useTranslation } from 'react-i18next';


interface OptionsMenuProps {
  onRename: () => void;
  onDelete: () => void;
}

const HistoryMenuList: React.FC<OptionsMenuProps> = ({ onRename, onDelete }) => {
    
  const { t: tAiGrading } = useTranslation('aiGrading_config');
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleRename = () => {
    onRename();
    handleClose();
  };

  const handleDelete = () => {
    onDelete();
    handleClose();
  };

  return (
    <>
      <IconButton onClick={handleClick}>
        <MoreAISvg />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: {
            mt: 1,
            borderRadius: 2,
            boxShadow: '0px 2px 12px rgba(0,0,0,0.15)',
            minWidth: 160,
            p: 0.5,
          },
        }}
      >
        <MenuItem onClick={handleRename}>
          <ListItemIcon>
            <EditIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary={tAiGrading('rename')} />
        </MenuItem>

        <MenuItem onClick={handleDelete} sx={{ color: 'error.main' }}>
          <ListItemIcon>
            <DeleteIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary={tAiGrading('delete')} />
        </MenuItem>
      </Menu>
    </>
  );
};

export default HistoryMenuList;
